import React, { useEffect, useRef, useState } from 'react';
import './BentoGallery.css';

const BentoGallery = () => {
  const [visibleItems, setVisibleItems] = useState(new Set());
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(null); // змінено!
  const observerRef = useRef(null);

  const photos = Array.from({ length: 42 }, (_, i) => ({
    id: i + 1,
    src: `/assets/${i + 1}.jpg`,
    alt: `TheaMou Fashion ${i + 1}`
  }));

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('data-id');
            setVisibleItems(prev => new Set([...prev, id]));
          }
        });
      },
      { threshold: 0.1, rootMargin: '50px' }
    );

    const items = document.querySelectorAll('.bento-item');
    items.forEach(item => observerRef.current.observe(item));

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxIndex(null);
    document.body.style.overflow = 'auto';
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setLightboxIndex(idx => (idx > 0 ? idx - 1 : photos.length - 1));
  };

  const showNext = (e) => {
    e.stopPropagation();
    setLightboxIndex(idx => (idx < photos.length - 1 ? idx + 1 : 0));
  };

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === 'Escape') closeLightbox(); };
    const handleArrows = (e) => {
      if (!lightboxOpen) return;
      if (e.key === 'ArrowLeft') showPrev(e);
      if (e.key === 'ArrowRight') showNext(e);
    };
    window.addEventListener('keydown', handleEscape);
    window.addEventListener('keydown', handleArrows);
    return () => {
      window.removeEventListener('keydown', handleEscape);
      window.removeEventListener('keydown', handleArrows);
    };
    // eslint-disable-next-line
  }, [lightboxOpen]);

  // Swipe support (optional, for mobile UX)
  useEffect(() => {
    let startX = null;
    const handleTouchStart = (e) => {
      if (!lightboxOpen) return;
      startX = e.touches[0].clientX;
    };
    const handleTouchEnd = (e) => {
      if (!lightboxOpen || startX === null) return;
      const delta = e.changedTouches[0].clientX - startX;
      if (delta > 50) showPrev(e);
      if (delta < -50) showNext(e);
      startX = null;
    };
    if (lightboxOpen) {
      document.addEventListener('touchstart', handleTouchStart);
      document.addEventListener('touchend', handleTouchEnd);
    }
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
    // eslint-disable-next-line
  }, [lightboxOpen, lightboxIndex]);

  return (
    <section className="bento-gallery">
      <div className="bento-header">
        <h2 className="bento-title">Athens Fashion Week 2025</h2>
        <p className="bento-subtitle">Inspired by the Ancient Olympics</p>
      </div>

      <div className="bento-grid">
        {photos.map((photo, index) => {
          const sizeClass =
            index % 7 === 0 ? 'large' :
            index % 11 === 0 ? 'wide' :
            index % 13 === 0 ? 'tall' :
            'regular';

          return (
            <div
              key={photo.id}
              data-id={photo.id}
              className={`bento-item ${sizeClass} ${visibleItems.has(String(photo.id)) ? 'visible' : ''}`}
              style={{ animationDelay: `${(index % 8) * 0.1}s` }}
              onClick={() => openLightbox(index)}
            >
              <img src={photo.src} alt={photo.alt} loading="lazy" />
              <div className="bento-item-overlay">
                <span className="item-number">{photo.id}</span>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="bento-logo-section">
        <img 
          src="/assets/MeaDea.png" 
          alt="MeaDea by Theo Logo" 
          className="meadea-logo"
        />
      </div>

      {lightboxOpen && lightboxIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="lightbox-close">&times;</span>
          <button className="lightbox-prev" onClick={showPrev}>&#60;</button>
          <img 
            src={photos[lightboxIndex].src} 
            alt={photos[lightboxIndex].alt} 
            className="lightbox-image"
            onClick={e => e.stopPropagation()}
          />
          <button className="lightbox-next" onClick={showNext}>&#62;</button>
        </div>
      )}
    </section>
  );
};

export default BentoGallery;
